<!-- <template>
  <div align="center">
    <div align="center" class="mt-6">
      <v-img width="70px" src="@/assets/MIHS_logo.png"></v-img>
    </div>
    <h1>Make It Home Safe</h1>
    <div v-if="SucessImg === true" align="center" class="mt-12">
      <v-img
        max-width="150px"
        src="https://cdn2.iconfinder.com/data/icons/greenline/512/check-512.png"
      ></v-img>
      Success
    </div>
    <div v-if="SucessImg === false" id="videoCapturingEl"></div>
  </div>
</template>

<script>
import IDVC from "@idscan/idvc2";
import "@idscan/idvc2/dist/css/idvc.css";
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      idvc: null,
      SucessImg: false,
      frontsaaku: "",
    };
  },
  mounted() {
    this.initializeIDVC();
  },
  methods: {
    initializeIDVC() {
      const self = this;
      let idvc = new IDVC({
        el: "videoCapturingEl",
        licenseKey:
          "eyJwZGY0MTdrZXkiOiJ0VFlnVkRLRDIydENwR253a2VNV0xseEpWNmZnR20ySzB6bDhPR1YvdkZVV2VNUjNjY21hSDJLbmpGVmp0aFJYT1x1MDAyQm02Vlx1MDAyQkdYQUQwbjhqR0ZlQ0d0bjRwUlZ4SWg4NWhBWmxQNGpDeFlKTUM1azJPWWU5VFNYQk4waVRUcnZZVGdGSFBQY0FYZ1x1MDAyQnNDejVkR0dFdkdabDlWVTV3S01kTWRVbFhqUEg0a0Y1NzA9IiwiY29tbW9uTGljZW5zZUtleSI6InpIQTdnVjdjL2xtVzg2dGtBcjhITG5rRWJXeGhDckI0SUtQZEJcdTAwMkJZYUREdldiaTRXXHUwMDJCRkFWbmtLRmR1UE9pM0dBNEp6a1RyejUzd2hvejlWb2NHdXBQYUJkXHUwMDJCbG8xb3RSZElEY1NkWlMvTUM3VmE5amZtaXBrQlRqV0h3d0V1dE9BOURYRTJyTEdDN05UeDZvZVx1MDAyQkdRYW5YVGU2WkVzZTlNZ1A2anViTVdVNlI0PSIsImltYWdlUHJvY2Vzc2luZ0tleSI6IlYvSlx1MDAyQjBcdTAwMkJ1UEpmdE5zWDVjVXVUZzUvRU9YbEo1b0JGSUtaVDR0Z0lnNzZEWVBhbVpHczJ5cHJaZEpCS3h3S1JzMVVUZDNyZXJ2QWZGRGRCMEkySVE2Z2ZUcWpHTklWQ05uYmxya1RsM2VhOUl6RDhqVUM5MjZQZFlYbG5xanA4YURrQmMyR09PZWNpaHVrbG5uV2F5M3J1SzBUZEF5MDNpTmtqb3RvR3pDa3c9IiwidHJhY2tTdHJpbmdQYXJzZXJLZXkiOiIxMEcyTTBieFx1MDAyQkFuTFlpNTVTV083bEVLVXlyRzRqQk1YMklrYTBCTEM0WlJlbVp5elhqbnBmNENLRjdVS3d4VXJjdGh5ZzQ0cTVKWEcwYS9pYzg4WVRlMkhheEJXM2d3RGtqdlx1MDAyQk04N2FkQ2pOZjI1MmVsXHUwMDJCbWFOS0pFUENNYUtiV1NaQlc1TTc3SUZhWldYeEpZcVg4ckQ0d2FUV2gyd2R5cUJ0ZTBxTzJBckE9IiwiaU9TTVJaRGV0ZWN0b3JLZXkiOiJnT0tiQzhxcWRzS0lMWk5VbnZETVJhWldkVWg3MER4RzE5cTFIOE1sQnltRzhMdGtSVE9Wd01PWXJGSU1zXHUwMDJCT0xyUTVpc2lPMHhpdGxEaFloeHBCUU1aZGZOSlZzR1x1MDAyQnZYRkhBNlMxWU9yWFA4dGd3dFx1MDAyQk1NSzBzQnBmRlA5bms4U3FZZVN3MVdCVjZKdFdZcHM5MUxWd0VQTENkNExwc3dRT055ZlJxMUxUZDQ9IiwiaU9TUERGRGV0ZWN0b3JLZXkiOiIqSy5McEtsS2FMdExlTGxOb0FvR2tEdVBwUC5GbkZlR3RQIn0=",
        networkUrl: "networks",
        chunkPublicPath: "networks",
        resizeUploadedImage: 800,
        fixFrontOrientAfterUpload: true,
        autoContinue: true,
        isShowDocumentTypeSelect: true,
        realFaceMode: "auto",
        useCDN: true,
        language: "en",
        isShowGuidelinesButton: true,
        documentTypes: [
          {
            type: "ID",
            steps: [
              {
                type: "front",
                name: "Document Front",
              },
              {
                type: "pdf",
                name: "Document Back",
              },
              {
                type: "face",
                name: "Face",
              },
            ],
          },
        ],
        onChange(data) {
          console.log("on change", data);
        },
        onCameraError(data) {
          console.log("camera error", data);
        },
        onReset(data) {
          console.log("on reset", data);
        },
        onRetakeHook(data) {
          console.log("retake hook", data);
        },
        clickGuidlines() {
          console.log("click Guidelines");
        },
        submit(data) {
          idvc.showSpinner(true);
          let frontStep, pdfStep, faceStep;
          let frontImage, backImage, faceImage;
          let captureMethod;
          let rawTrackString;

          switch (data.documentType) {
            case 1:
              console.log("data", data);
              frontStep = data.steps.find((item) => item.type === "front");
              pdfStep = data.steps.find((item) => item.type === "pdf");
              faceStep = data.steps.find((item) => item.type === "face");

              frontImage = frontStep.img.split(
                /:image\/(jpeg|png|webp|jpg);base64,/
              )[2];
              backImage = pdfStep.img.split(
                /:image\/(jpeg|png|webp|jpg);base64,/
              )[2];
              faceImage = faceStep.img.split(
                /:image\/(jpeg|png|webp|jpg);base64,/
              )[2];

              self.frontsaaku = frontImage;

              rawTrackString =
                pdfStep && pdfStep.trackString ? pdfStep.trackString : "";

              captureMethod =
                JSON.stringify(+frontStep.isAuto) +
                JSON.stringify(+pdfStep.isAuto) +
                JSON.stringify(+faceStep.isAuto);

              break;

            default:
          }

          const trackStringArray = rawTrackString.split(".");
          let trackString = trackStringArray[0];
          let barcodeParams = trackStringArray[1];

          let request = {
            frontImageBase64: frontImage,
            backOrSecondImageBase64: backImage,
            faceImageBase64: faceImage,
            documentType: data.documentType,
            trackString: {
              data: trackString,
              barcodeParams: barcodeParams,
            },
            overriddenSettings: {
              isOCREnabled: true,
              isBackOrSecondImageProcessingEnabled: true,
              isFaceMatchEnabled: true,
            },
            metadata: {
              captureMethod: captureMethod,
            },
          };

          // console.log("frontStep", frontStep);
          // let keyvalue = new Date().getTime();
          // self.GenerateUploadURLMethods(keyvalue, frontStep);

          fetch("https://dvs2.idware.net/api/v4/verify", {
            method: "POST",
            headers: {
              Authorization: "Bearer sk_1b67d13d-6713-4fea-8c52-9dd208243bee",
              "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify(request),
          })
            .then((response) => response.json())
            .then((data) => {
              idvc.showSpinner(false);
              console.log("daaaaaaada", data);
              if (data.code && data.code == "MultipleErrors") {
                alert("Somthing went wrong");
              } else {
                self.SucessImg = true;
                self.SendMotoristProfileMethod();
              }
            })
            .catch((err) => {
              idvc.showSpinner(false);
              console.log("error", err);
            });
        },
      });
    },
    async GenerateUploadURLMethods(key, file) {
      var dataInput = {
        key: key,
      };
      await axios
        .post(
          "https://ck1o4ahf2l.execute-api.us-east-1.amazonaws.com/s3_upload/get_s3_url",
          dataInput
        )
        .then((response) => {
          this.loading = false;
          console.log("generateIMag", response);
          if (response.status == 200) {
            this.uploadS3Method(key, response.data.message, file);
          }
        })
        .catch((Error) => {
          this.loading = false;
          console.log("Error", Error);
        });
    },

    async uploadS3Method(key, uploadURL, file) {
      try {
        const config = {
          method: "put",
          maxBodyLength: Infinity,
          url: uploadURL,
          headers: {
            "Content-Type": file.type,
          },
          data: file,
        };

        const result = await axios(config);
        console.log("uploadS3Methodmethod", result);

        // if (result.status === 200 && result.statusText === "OK") {
        //   this.getS3FileMethod(key);
        // }
      } catch (error) {
        console.log("Error uploading to S3:", error);
      }
    },
    // async getS3FileMethod(key) {
    //   try {
    //     let config = {
    //       method: "post",
    //       maxBodyLength: Infinity,

    //       url: "https://ck1o4ahf2l.execute-api.us-east-1.amazonaws.com/s3_download/get_s3_file",
    //       data: { key: key },
    //     };
    //     let result = await axios(config);
    //     console.log("result", result);
    //     if (result.data.status === "Success") {
    //       this.GetBase64MethodFromPreSignedURLMethod(result.data.message);
    //     }
    //   } catch (error) {
    //     console.log("Err", error);
    //   }
    // },
    // async GetBase64MethodFromPreSignedURLMethod(PreSignedURL) {
    //   try {
    //     let config = {
    //       method: "get",
    //       maxBodyLength: Infinity,
    //       url: PreSignedURL,
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     };
    //     let result = await axios(config);
    //     console.log("BaseResult", result);
    //     if (result.status === 200 && result.statusText === "OK") {
    //       return result.data;
    //     }
    //   } catch (error) {
    //     console.log("error", error);
    //   }
    // },
    async SendMotoristProfileMethod() {
      var dataInput = {
        user_id: "$inputRoot.user_id",
        profile_pic_url: "$inputRoot.profile_pic_url",
        license_front_url: "$inputRoot.license_front_url",
        license_back_url: "$inputRoot.license_back_url",
        command: "updateDriversDetails",
      };
      await axios
        .post(
          "https://2jiaqhsmzb.execute-api.us-east-1.amazonaws.com/prod/update_driver_urls",
          dataInput
        )
        .then((response) => {
          if (response.status == 200) {
            // this.SnackBarComponent = {
            //   SnackbarVmodel: true,
            //   SnackbarColor: "green",
            //   Top: true,
            //   SnackbarText: "Form Submitted Successfully",
            // };
            // this.SubmitText = true;
            console.log("respones upload", response);
          }
        })
        .catch((Error) => {
          this.loading = false;
          console.log("Error", Error.response);
        });
    },
  },
};
</script>

<style></style> -->

<template>
  <div>
    <h1>Get User's Current Location</h1>
    <button @click="getLocation">Get My Location</button>
    <div id="map" style="height: 400px; width: 100%"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      map: null,
      marker: null,
    };
  },
  methods: {
    // initMap(lat, lng) {
    //   const userLocation = { lat, lng };
    //   this.map = new google.maps.Map(document.getElementById("map"), {
    //     center: userLocation,
    //     zoom: 15,
    //   });

    //   this.marker = new google.maps.Marker({
    //     position: userLocation,
    //     map: this.map,
    //     title: "You are here!",
    //   });
    // },
    getLocation() {
      if (navigator.geolocation) {
        let lastUpdateTime = 0;
        navigator.geolocation.watchPosition(
          (position) => {
            const currentTime = Date.now();

            if (currentTime - lastUpdateTime >= 90000) {
              console.log("position", position);
              lastUpdateTime = currentTime;
              const lat = position.coords.latitude;
              const lng = position.coords.longitude;
              this.latitude = lat;
              this.longitude = lng;
            }
          },
          (error) => {
            console.error("Geolocation error:", error);
          },
          {
            enableHighAccuracy: true, // Use GPS for better accuracy
            maximumAge: 0, // Always request fresh data
            timeout: 90000, // Wait up to 90 seconds for an update
          }
        );
      } else {
        alert("Geolocation is not supported by your browser.");
      }
    },
  },
};
</script>

<!-- <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY"></script> -->
